import React, { useMemo, useState } from 'react';
import { SlideDown } from 'react-slidedown';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Requester } from 'models/travelDetails';

import { Arrow, Card, Header, Label, PassengerIcon, Row, Title, Value } from './styles';

interface Props {
  requester: Requester;
}
const PassengerBox = ({ requester }: Props) => {
  const { t } = useStoreTranslation();

  const [show, setShow] = useState(false);

  const formattedBirthDate = useMemo(() => moment.utc(requester.birthDate).format('DD/MM/YYYY'), [requester.birthDate]);

  return (
    <Card>
      <Header onClick={() => setShow(!show)}>
        <Title>
          <PassengerIcon />
          {requester.fullName}
        </Title>
        <Arrow className={show ? 'active' : ''} />
      </Header>
      <SlideDown closed={!show}>
        <Row>
          <Label>{t('travelDetails.passenger.document')}</Label>
          <Value>{requester.documentNumber}</Value>
        </Row>
        <Row>
          <Label>{t('travelDetails.passenger.birthDate')}</Label>
          <Value>{formattedBirthDate}</Value>
        </Row>
        {requester.phoneNumber && (
          <Row>
            <Label>{t('travelDetails.passenger.phoneNumber')}</Label>
            <Value>{requester.phoneNumber}</Value>
          </Row>
        )}
        {requester.email && (
          <Row>
            <Label>{t('travelDetails.passenger.email')}</Label>
            <Value>{requester.email}</Value>
          </Row>
        )}
      </SlideDown>
    </Card>
  );
};

export default PassengerBox;
